import { defineStore } from "pinia";
import { ref } from "vue";
import type { currencyType } from "../service/currencyType/types";

export const useCurrencyTypesStore = defineStore(
  "currencyType",
  () => {
    const currencyTypes = ref<currencyType[]>([]);
    const selectedCurrency = ref<currencyType | null>(null);

    // Actions
    function setCurrencyTypes(types: currencyType[]) {
      currencyTypes.value = types;
    }

    function clearCurrencyTypes() {
      currencyTypes.value = [];
      selectedCurrency.value = null;
    }

    function setSelectedCurrency(currency: currencyType | null) {
      selectedCurrency.value = currency;
    }

    function getCurrencyTypes(): currencyType[] {
      return currencyTypes.value;
    }

    return {
      currencyTypes,
      selectedCurrency,
      setCurrencyTypes,
      clearCurrencyTypes,
      setSelectedCurrency,
      getCurrencyTypes,
    };
  },
  {
    persist: true,
  }
);
